/*
 * @Descripttion:
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2020-07-06 12:17:06
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @LastEditTime: 2023-08-18 14:29:08
 */
import base from './base'
import survey from './survey'
import data from './data'
import count from './count'
import map from './map'
import mall from './mall'
import service from './service'
import technician from './technician'
import market from './market'
import shop from './shop'
import distribution from './distribution'
import coachbroker from './coachbroker'
import salesman from './salesman'
import channel from './channel'
import agent from './agent'
import finance from './finance'
import dynamic from './dynamic'
import store from './store'
import custom from './custom'
import member from './member'
import notice from './notice'
import adapay from './adapay'
import account from './account'
import diy from './diy'
import system from './system'
import upload from './upload'
let modules = {
  base, survey, data, count, map, mall, service, technician, market, shop, distribution, coachbroker, salesman, channel, agent, finance, dynamic, store, custom, member, notice, adapay, account, diy, system, upload
}
export default {
  ...modules
}



// WEBPACK FOOTER //
// ./src/api/modules/index.js